module.exports = __webpack_public_path__ + "static/media/box4-inset.7654c6ae.jpeg";